/** Адреса службы Cashiers для РМК «Собственной» (CLAUDE.md §7: URL строкой — только в `api/urls.ts`). Вход — по кассиру нашей системы (RP-CU4). */
export const OWN_POS_CASHIER_URLS = {
  /** `GET ?resourceId=` — кассиры нашей системы, связанные с кассиром этого источника; архивные не приходят. */
  list: '/api/cashiers/v1/people/workplace',
  /** `POST { code, cashierId }` — код выбранного кассира → билет входа этой вкладки и его рабочие места. */
  signIn: '/api/cashiers/v1/people/sign-in',
  /** `POST { ticket, resourceId, sourceCashierId }` — пропуск РМК на кассира источника по билету входа. */
  grant: '/api/cashiers/v1/people/grants',
} as const
